module.exports = __webpack_public_path__ + "static/media/notice-4.a5ef2c98.jpg";